import http from '../httpService';

const AssociationMaterialService = {
  getAssociationMaterial: params => http.get('association-material', { params }),
};

export default AssociationMaterialService;
